import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { getLocalizedPath } from "@/utils/helper";
import { ROUTE_CONSTANT } from "@/routing/route-constants";
import { clearLastOrderRef, clearOnboardingSession } from "@/utils/onboardingSession";

/**
 * Navigation between the song order routes. The order's docId / uId ride along
 * on every hop, so the destination page resolves the same order.
 */
export default function useSongOrderNavigation() {
  const navigate = useNavigate();
  const { locale } = useParams<{ locale?: string }>();
  const localeVal = locale ?? "";
  const [searchParams] = useSearchParams();

  const go = (Path: string, LocalePath: string, query: string) =>
    navigate(`${getLocalizedPath(localeVal, { Path, LocalePath })}?${query}`);

  const orderQuery = () => searchParams.toString();

  return {
    goToTrackSong: () =>
      go(
        ROUTE_CONSTANT.TRACK_SONG,
        ROUTE_CONSTANT.TRACK_SONG_LOCALE,
        orderQuery(),
      ),
    goToNewSong: () => {
      clearOnboardingSession();
      clearLastOrderRef();
      const path = getLocalizedPath(localeVal, {
        Path: ROUTE_CONSTANT.MUSIC_EDITOR,
        LocalePath: ROUTE_CONSTANT.MUSIC_EDITOR_LOCALE,
      });
      window.location.assign(`${path}?onboarding=true&fresh=1`);
    },
  };
}
